
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const heavyBtn = document.getElementById("heavyBtn");
      const thrashingBtn = document.getElementById("thrashingBtn");
      const clearBtn = document.getElementById("clearBtn");
      const frameInfo = document.getElementById("frameInfo");
      const comparison = document.getElementById("comparison");
      const comparisonBody = document.getElementById("comparisonBody");

      checkLoafSupport();

      let lastHeavyFrame = null;
      let lastThrashingFrame = null;

      // Observer de LoAF
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          analyzeFrame(entry);
        }
      });

      try {
        observer.observe({
          type: "long-animation-frame",
          buffered: true,
        });
      } catch (e) {
        logger.error("LoAF no soportado");
      }

      function analyzeFrame(entry) {
        logger.log("");
        logger.log("═══════════════════════════════════════════════════");
        logger.log("📊 LONG ANIMATION FRAME DETECTADO");
        logger.log("═══════════════════════════════════════════════════");
        logger.log("");

        logger.log("Métricas generales:");
        logger.log(`   • Duration: ${entry.duration.toFixed(2)}ms`);
        logger.log(`   • Blocking duration: ${entry.blockingDuration.toFixed(2)}ms`);
        logger.log(
          `   • Forced layout: ${entry.scripts[0]?.forcedStyleAndLayoutDuration.toFixed(2) || 0}ms`,
        );
        logger.log("");

        // Calcular ratio
        const script = entry.scripts[0];
        if (script) {
          const forcedLayoutRatio = (script.forcedStyleAndLayoutDuration / script.duration) * 100;

          logger.log("Análisis:");
          logger.log(`   • Ratio de forced layout: ${forcedLayoutRatio.toFixed(1)}%`);
          logger.log("");

          // Diagnóstico
          if (forcedLayoutRatio > 50) {
            logger.warn("🔴 PROBLEMA DETECTADO: Layout thrashing severo");
            logger.warn("   Más del 50% del tiempo fue recalcular layout");
            logger.warn("");
            logger.log("💡 Solución:");
            logger.log("   1. Separar lecturas y escritas del DOM");
            logger.log("   2. Hacer batch de todas las lecturas primero");
            logger.log("   3. Luego hacer batch de todas las escrituras");
            logger.log("");

            // Actualizar info
            frameInfo.innerHTML = `
            <div class="metric poor">
              Layout thrashing: ${forcedLayoutRatio.toFixed(1)}%
              <small style="display: block; font-weight: normal; margin-top: 4px;">
                ${script.forcedStyleAndLayoutDuration.toFixed(2)}ms de ${script.duration.toFixed(2)}ms
              </small>
            </div>
          `;

            lastThrashingFrame = {
              duration: entry.duration,
              forced: script.forcedStyleAndLayoutDuration,
              ratio: forcedLayoutRatio,
            };
          } else if (script.duration > 100) {
            logger.warn("🟡 PROBLEMA DETECTADO: Cálculo pesado");
            logger.warn("   El script tarda mucho pero NO es layout thrashing");
            logger.warn("");
            logger.log("💡 Solución:");
            logger.log("   1. Mover cálculos pesados a Web Workers");
            logger.log("   2. Dividir el trabajo en chunks más pequeños");
            logger.log("   3. Optimizar algoritmos");
            logger.log("");

            // Actualizar info
            frameInfo.innerHTML = `
            <div class="metric needs-improvement">
              Script pesado: ${script.duration.toFixed(2)}ms
              <small style="display: block; font-weight: normal; margin-top: 4px;">
                Sin layout thrashing (${forcedLayoutRatio.toFixed(1)}%)
              </small>
            </div>
          `;

            lastHeavyFrame = {
              duration: entry.duration,
              forced: script.forcedStyleAndLayoutDuration,
              ratio: forcedLayoutRatio,
            };
          }

          // Mostrar función responsable
          if (script.sourceFunctionName) {
            logger.log(`🎯 Función responsable: ${script.sourceFunctionName}`);
            logger.log("");
          }

          // Actualizar comparación si tenemos ambos
          updateComparison();
        }

        logger.log("═══════════════════════════════════════════════════");
        logger.log("");
      }

      function updateComparison() {
        if (!lastHeavyFrame || !lastThrashingFrame) return;

        comparison.style.display = "block";

        comparisonBody.innerHTML = `
        <tr>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);"><strong>Duration total</strong></td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">${lastHeavyFrame.duration.toFixed(2)}ms</td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">${lastThrashingFrame.duration.toFixed(2)}ms</td>
        </tr>
        <tr style="background-color: var(--color-bg-secondary);">
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);"><strong>Forced layout</strong></td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">${lastHeavyFrame.forced.toFixed(2)}ms</td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">${lastThrashingFrame.forced.toFixed(2)}ms</td>
        </tr>
        <tr>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);"><strong>Ratio de thrashing</strong></td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">
            <span style="color: var(--color-success);">${lastHeavyFrame.ratio.toFixed(1)}% ✓</span>
          </td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">
            <span style="color: var(--color-danger);">${lastThrashingFrame.ratio.toFixed(1)}% ✗</span>
          </td>
        </tr>
        <tr style="background-color: var(--color-bg-secondary);">
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);"><strong>Diagnóstico</strong></td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">Cálculo puro</td>
          <td style="padding: 0.75rem; border: 1px solid var(--color-border);">Layout thrashing</td>
        </tr>
      `;
      }

      // Botón de script pesado
      heavyBtn.addEventListener("click", function heavyComputation() {
        logger.log("🔵 Ejecutando script pesado (cálculo puro)...");

        const start = performance.now();
        let result = 0;

        // Cálculo pesado sin tocar el DOM
        while (performance.now() - start < 200) {
          for (let i = 0; i < 1000; i++) {
            result += Math.sqrt(i) * Math.random();
          }
        }

        logger.log(`✅ Completado (resultado: ${result.toFixed(2)})`);
        logger.log("⏳ Esperando análisis de LoAF...");
      });

      // Botón de layout thrashing
      thrashingBtn.addEventListener("click", function triggerLayoutThrashing() {
        logger.log("🔴 Ejecutando layout thrashing...");

        // Crear elementos si no existen
        let container = document.getElementById("thrashingContainer");
        if (!container) {
          container = document.createElement("div");
          container.id = "thrashingContainer";
          container.style.position = "absolute";
          container.style.left = "-9999px";
          container.style.width = "500px";
          document.body.appendChild(container);

          // Crear muchos más elementos con estructura más compleja
          for (let i = 0; i < 500; i++) {
            const div = document.createElement("div");
            div.className = "thrashing-item";
            div.textContent = `Item ${i}`;
            div.style.padding = "10px";
            div.style.border = "1px solid #ccc";
            div.style.margin = "2px";
            container.appendChild(div);
          }
        }

        const elements = container.querySelectorAll(".thrashing-item");
        const start = performance.now();

        // Layout thrashing: múltiples iteraciones de leer y escribir alternado
        for (let iteration = 0; iteration < 3; iteration++) {
          elements.forEach((el) => {
            // LEER (fuerza layout)
            const height = el.offsetHeight;
            const width = el.offsetWidth;

            // ESCRIBIR (invalida layout)
            el.style.width = width + 1 + "px";
            el.style.height = height + 1 + "px";

            // Más lecturas (fuerzan más recálculos)
            const top = el.offsetTop;
            const left = el.offsetLeft;

            // Más escrituras
            el.style.marginTop = "3px";

            // → Cada lectura después de escritura fuerza recálculo completo
          });
        }

        const elapsed = performance.now() - start;

        logger.log(`✅ Completado en ${elapsed.toFixed(2)}ms`);
        logger.log("⏳ Esperando análisis de LoAF...");
      });

      // Limpiar
      clearBtn.addEventListener("click", () => {
        logger.clear();
        frameInfo.innerHTML = "Haz clic en uno de los botones...";
        comparison.style.display = "none";
        lastHeavyFrame = null;
        lastThrashingFrame = null;
        showInitialMessage();
      });

      function showInitialMessage() {
        logger.log("👋 Haz clic en los botones para comparar script pesado vs layout thrashing");
        logger.log("📌 Observa la diferencia en forcedStyleAndLayoutDuration");
        logger.log("");
      }

      // Mensaje inicial
      showInitialMessage();
    